import { createFileRoute, notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { NOT_FOUND_HEAD_FALLBACK } from "@/lib/brandIcons";
import { blogTermHead } from "@/lib/blog/seo";
import { TermPage } from "#/components/blog/TermPage";

// See the list route: cache only a 200, never a notFound()/404 — an unknown tag
// slug must not be edge-cached as missing.
const CACHE = "public, s-maxage=60, stale-while-revalidate=86400";

const getTagPosts = createServerFn({ method: "GET" })
  .validator((tag: string) => tag)
  .handler(async ({ data: tag }) => {
    const { loadBlogTerm, resolveDogfoodWorkspaceId } = await import(
      "@/lib/blog/queries"
    );
    const workspaceId = resolveDogfoodWorkspaceId();
    return workspaceId
      ? await loadBlogTerm(workspaceId, "tags", tag)
      : undefined;
  });

export const Route = createFileRoute("/blog/tags/$tag")({
  ssr: true,
  loader: async ({ params }) => {
    const data = await getTagPosts({ data: params.tag });
    if (!data) throw notFound();
    return data;
  },
  headers: ({ loaderData }) =>
    loaderData ? { "cache-control": CACHE } : { "cache-control": "no-store" },
  // notFound()-branch icon fallback + the `as never` cast it needs: see
  // `NOT_FOUND_HEAD_FALLBACK`'s docblock (#1099 / US2).
  head: ({ loaderData }) =>
    (loaderData
      ? blogTermHead(
          loaderData.blog,
          loaderData.kind,
          loaderData.term,
          loaderData.canonical,
          loaderData.feedUrl,
        )
      : NOT_FOUND_HEAD_FALLBACK) as never,
  component: BlogTagPage,
});

function BlogTagPage() {
  const { kind, term, posts } = Route.useLoaderData();
  return <TermPage kind={kind} term={term} posts={posts} />;
}
